import NoImagePlaceholder from 'assets/no-image-placeholder.png'
import { useNavigate } from 'react-router-dom'
import Button from '../../components/Button'
import { truncate } from '../../utils/functions'
import { useAddItemsFromRecipeMutation, useGetSingleListQuery } from '../lists/queries'
import { useAddRecipesToMenuMutation, useGetSingleMenuQuery, useRemoveRecipeFromMenuMutation } from '../menus/queries'

type RecipeInListProps = {
    id: number
    name: string
    category: string | null
    imageUrl: string | null
}

export function RecipeInList({ id, name, category, imageUrl }: RecipeInListProps) {
    // If this screen has been accessed by pressing add recipe or list to menu button, we need to show slightly different UI.
    const isAddRecipeToMenu = false // TODO
    const menuId = '1' // TODO

    const isAddRecipeToList = false // TODO
    const listId = '2' // TODO

    const navigate = useNavigate()

    const { data: singleMenuData } = useGetSingleMenuQuery(menuId || '', isAddRecipeToMenu)
    const { mutate: addRecipeToMenu } = useAddRecipesToMenuMutation()
    const { mutate: removeRecipeFromMenu } = useRemoveRecipeFromMenuMutation()

    const isRecipeAlreadyInMenu = singleMenuData?.recipes.some((recipe) => recipe.id === id)

    const { data: singleListData } = useGetSingleListQuery(listId || '', isAddRecipeToList)
    const { mutate: addRecipeToList, isLoading: isAddRecipeToListLoading, variables: recipeBeingAddedToList } = useAddItemsFromRecipeMutation()

    function handleRecipeClick() {
        if (isAddRecipeToMenu || isAddRecipeToList) {
            return
        }

        navigate(`/recipes/edit/${id}`)
    }

    return (
        <button type='button' onClick={handleRecipeClick} className='text-left'>
            <img src={imageUrl || NoImagePlaceholder} className='h-44 w-full object-cover rounded-md' />
            <div className='mt-2'>
                <div>
                    <p>{truncate(name)}</p>
                    <p className='text-primary text-sm'>{category ?? 'Uncategorized'}</p>
                </div>
                {isAddRecipeToMenu && !isRecipeAlreadyInMenu && (
                    <Button
                        onClick={() => {
                            addRecipeToMenu({ menuId: menuId || '', recipes: [{ id: id.toString(), day: null }] })
                        }}
                    >
                        Add To Menu
                    </Button>
                )}
                {!!singleMenuData && isAddRecipeToMenu && isRecipeAlreadyInMenu && (
                    <div>
                        {/* <MaterialCommunityIcon name='check-circle-outline' size={32} color={semantic.colorTextPrimary} /> */}
                        <Button
                            onClick={() => {
                                removeRecipeFromMenu({ menuId: menuId || '', recipeId: id })
                            }}
                        >
                            Remove
                        </Button>
                    </div>
                )}
                {!!singleListData && isAddRecipeToList && (
                    <Button
                        onClick={() => {
                            addRecipeToList({ listId: listId || '', recipeId: id.toString() }, { onSuccess: () => navigate(-1) })
                        }}
                        loading={isAddRecipeToListLoading && recipeBeingAddedToList?.recipeId === id.toString()}
                    >
                        Add To List
                    </Button>
                )}
            </div>
        </button>
    )
}
